export type BadgeColor = 'blue' | 'green' | 'red' | 'gray' | 'purple' | 'yellow' | 'orange';

// 키가 곧 색 이름인 팔레트라 blue를 brand로 바꾸지 않는다 —
// `color="blue"`가 인디고를 그리면 API가 거짓말이 된다. 브랜드색이 필요하면 키를 새로 열 것.
const BADGE_COLOR_CLASSES: Record<BadgeColor, string> = {
  blue: 'bg-blue-100 text-blue-700',
  green: 'bg-green-100 text-green-700',
  red: 'bg-red-100 text-red-700',
  gray: 'bg-gray-100 text-gray-600',
  purple: 'bg-purple-100 text-purple-700',
  yellow: 'bg-yellow-100 text-yellow-800',
  orange: 'bg-orange-100 text-orange-700',
};

/**
 * 공통 Badge 컴포넌트.
 * - `className` 직접 전달: Tailwind 클래스 직접 지정 (UserFeedback 등)
 * - `color` preset 전달: 사전 정의된 색상 프리셋 사용 (ExternalServices 등)
 */
export function Badge({
  label,
  text,
  color,
  className,
}: {
  label?: string;
  text?: string;
  color?: BadgeColor;
  className?: string;
}) {
  const displayText = label ?? text ?? '';
  const colorClass = className ?? (color ? BADGE_COLOR_CLASSES[color] : 'bg-gray-100 text-gray-600');

  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${colorClass}`}>
      {displayText}
    </span>
  );
}
